//
// If a page requires some special JS code, just stab an element onto the page with
// data-requires-module="the_module" and it will load it from dynamic/ once the page is
// ready, without needing to load that JS file on every other page.
//

$(function() {
  $("[data-module-binding]").each(function(i, element) {
    require('./modules/' + element.getAttribute('data-module-binding'));
  });
});